var map = {
	"./addtoprofilebutton_de.png": 106,
	"./addtoprofilebutton_en.png": 107,
	"./addtoprofilebutton_fr.png": 108,
	"./award_land_der_ideen.jpg": 109,
	"./b2b_award_logo.png": 110,
	"./cc.png": 111,
	"./certificate_sample.jpg": 112,
	"./changelog_avatar.png": 113,
	"./clear.png": 114,
	"./companies.jpg": 115,
	"./course-cover-default.jpg": 116,
	"./course-page-card_big.png": 117,
	"./course-page-card_image.png": 118,
	"./course-page-card_image_inline.png": 119,
	"./course-page-card_inline.png": 120,
	"./course-page-card_small.png": 121,
	"./course-placeholder.jpg": 122,
	"./course_default.png": 123,
	"./download-easy-guide.jpg": 124,
	"./drag_dark.png": 125,
	"./drag_light.png": 126,
	"./draggable.png": 127,
	"./example_voucher_card_de.jpg": 128,
	"./example_voucher_card_en.jpg": 129,
	"./example_voucher_card_fr.jpg": 130,
	"./fabian.jpg": 131,
	"./female_speaker_bg.jpg": 132,
	"./focus_seal.png": 133,
	"./h5p_docu_1.png": 134,
	"./h5p_docu_2.png": 135,
	"./loading.gif": 136,
	"./logo-iversity-without-padding.png": 137,
	"./logo-iversity.png": 138,
	"./logo_highres.png": 139,
	"./logo_iversity_springer.svg": 140,
	"./organisation_purchase.jpg": 141,
	"./petal_cutted.png": 142,
	"./posters_points.png": 143,
	"./professor_bg.jpg": 144,
	"./purchase_voucher_header.jpg": 145,
	"./referrals.jpg": 146,
	"./speech-bubble.svg": 147,
	"./voucher_card.png": 148,
	"./work_with_us.png": 149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;